import { render, staticRenderFns } from "./UiDate.vue?vue&type=template&id=33ca170b"
import script from "./UiDate.vue?vue&type=script&lang=js"
export * from "./UiDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports